import React from 'react';

import MarkerOverlayContent from './MarkerOverlayContent';
import track from '../../../lib/track';
import { NewMarkerIcon } from '../Icons';
import { ListingStatus } from '../../../lib/constants';
import styles from './styles';

interface Props {
  isOverlayShown: boolean;
  lat: any;
  listing: any;
  lng: any;
  marker: any;
  markerClicked: string;
  markerFocused: string;
  onMarkerClick: Function;
  onMouseLeaveMarker: Function;
  onMouseOverMarker: Function;
  overlayListing: any;
  router: any;
  selectedListing: any;
}

export const CustomMarker = (props: Props) => {
  const {
    isOverlayShown,
    listing,
    marker,
    markerClicked,
    markerFocused,
    onMarkerClick,
    onMouseLeaveMarker,
    onMouseOverMarker,
    overlayListing,
    selectedListing,
    router,
  } = props;
  let markerIndex = 0;
  if (markerClicked === listing.id) {
    markerIndex = 200;
  } else if (listing.status === ListingStatus.New) {
    markerIndex = 90;
  } else if (overlayListing.id === listing.id) {
    markerIndex = 100;
  } else if (markerFocused === listing.id) {
    markerIndex = 100;
  }

  return (
    <div
      onMouseDown={() =>
        track.buttonClick(`Marker: ${listing.id}`, router.pathname, '')
      }
    >
      {isOverlayShown && overlayListing.id === listing.id && (
        <div
          style={{
            position: 'absolute',
            zIndex: 300,
            ...styles.overlayContainer,
          }}
        >
          <MarkerOverlayContent overlayListings={[overlayListing]} />
        </div>
      )}
      {markerClicked && selectedListing.id === listing.id && (
        <div
          style={{
            position: 'absolute',
            zIndex: 250,
            ...styles.overlayContainer,
          }}
        >
          <MarkerOverlayContent overlayListings={[selectedListing]} />
        </div>
      )}
      <div
        style={{
          position: 'absolute',
          zIndex: markerIndex,
          ...styles.markerIconStyle,
        }}
        onMouseOver={() => onMouseOverMarker(listing)}
        onMouseLeave={() => onMouseLeaveMarker()}
        onClick={() => onMarkerClick(listing)}
      >
        {listing.status === ListingStatus.New && (
          <div
            style={{
              position: 'relative',
              zIndex: markerIndex - 1,
              ...styles.newMarkerStyle,
            }}
          >
            <NewMarkerIcon />
          </div>
        )}
        <div
          style={{
            position: 'relative',
            zIndex: markerIndex + 1,
          }}
        >
          {marker}
        </div>
      </div>
    </div>
  );
};

export default CustomMarker;
